import { trigger, transition, style, animate } from '@angular/animations';
import { Component, ChangeDetectorRef } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-faq-chat-kachiing',
  templateUrl: './faq-chat-kachiing.component.html',
  styleUrl: './faq-chat-kachiing.component.scss',
  animations: [
    trigger('pageTransition', [
      transition('* => forward', [
        style({ opacity: 0, transform: 'translateX(100%)' }),
        animate(
          '0.4s ease-in-out',
          style({ opacity: 1, transform: 'translateX(0)' })
        ),
      ]),
      transition('* => backward', [
        style({ opacity: 0, transform: 'translateX(-100%)' }),
        animate(
          '0.4s ease-in-out',
          style({ opacity: 1, transform: 'translateX(0)' })
        ),
      ]),
    ]),
    trigger('fadeInOut', [
      transition('* => *', [
        style({ opacity: 0, transform: 'translateY(20px)' }),
        animate(
          '0.5s ease-in-out',
          style({ opacity: 1, transform: 'translateY(0)' })
        ),
      ]),
    ]),
  ],
})
export class FaqChatKachiingComponent {
  public imageUrl = environment.ImageUrl;

  // UI Data
  public currentPageIndex = 0;
  public animationDirection: 'forward' | 'backward' = 'forward';

  public defaultDescription =
    "Find something good > Reinforces that Biz<br>Don't find anything good > Recommend for next person to benefit";

  public contentList = [
    {
      icon: 'icon',
      color: '',
      title: 'Be Respectful',
      content:
        'No personal attacks, harassment, rude comments, or unnecessary drama. Treat everyone like a human being.',
    },
    {
      icon: 'icon',
      color: '',
      title: 'Stay Relevant',
      content:
        'Keep discussions related to the topic & on point. Avoid spamming, flooding, or derailing conversations.',
    },
    {
      icon: 'icon',
      color: '',
      title: 'No Illegal or Harmful Content',
      content:
        'Do not share scams, links, NSFW materials, hate speech, or anything that endangers others.',
    },
    {
      icon: 'icon',
      color: '',
      title: 'Protect Privacy',
      content:
        'Do not share anyone’s personal information (addresses, phone numbers, photos, screenshots) without permission.',
    },
  ];

  constructor(
    public activeModal: NgbActiveModal,
    private cdr: ChangeDetectorRef
  ) {}

  // ---------------------------
  // 🔵 Utility Getters
  // ---------------------------

  get currentItem() {
    return this.contentList[this.currentPageIndex] ?? null;
  }

  get displayTitle(): string {
    return this.currentItem?.title ?? 'Search Kachiing';
  }

  get displayText(): string {
    return this.currentItem?.content ?? this.defaultDescription;
  }

  get displayIcon(): string {
    return this.currentItem?.icon ?? '';
  }

  get displayColor(): string | null {
    return this.currentItem?.color ?? null;
  }

  get isLastPage(): boolean {
    return this.currentPageIndex >= this.contentList.length - 1;
  }

  get pageIndicator(): string {
    return `${this.currentPageIndex + 1} / ${this.contentList.length}`;
  }

  // ---------------------------
  // 🔵 Lifecycle
  // ---------------------------

  // ---------------------------
  // 🔵 Icon Helpers
  // ---------------------------

  isIconImage(): boolean {
    return this.displayIcon.includes('public/');
  }

  getIconImageUrl(): string {
    return this.isIconImage() ? this.imageUrl + this.displayIcon : '';
  }

  // ---------------------------
  // 🔵 Navigation
  // ---------------------------

  nextPage(): void {
    if (!this.isLastPage) {
      this.animationDirection = 'forward';
      this.currentPageIndex++;
      this.cdr.detectChanges();
    }
  }

  // ---------------------------
  // 🔵 Colors
  // ---------------------------

  private colorMap: Record<string, string> = {
    primary: '#592880',
    secondary: '#b32596',
    emerald: '#10b981',
    indigo: '#4f46e5',
    violet: '#7c3aed',
    teal: '#14b8a6',
    blue: '#3b82f6',
    purple: '#9333ea',
    pink: '#ec4899',
    cyan: '#06b6d4',
  };

  getColorHex(color: string) {
    return this.colorMap[color] ?? '#4EC67F';
  }

  getColorStyle(color: string | null) {
    if (!color) return null;

    if (color === 'primary') return { color: 'var(--primary)' };
    if (color === 'secondary') return { color: 'var(--secondary)' };

    return { color: this.getColorHex(color) };
  }

  getButtonBackgroundColor(color: string | null): string {
    if (!color) return '#4EC67F';
    if (color === 'primary') return 'var(--primary)';
    if (color === 'secondary') return 'var(--secondary)';
    return this.getColorHex(color);
  }

  // ---------------------------
  // 🔵 Modal Actions
  // ---------------------------

  close() {
    this.activeModal.close();
  }

  gotIt() {
    this.activeModal.close();
  }
}
